import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { Box, Step, StepLabel, Stepper } from "@mui/material";
import styles from "./multistepForm.module.scss";
import { styled } from "@mui/system";
import i18next from "i18next";
import FormFooterSection from "./FormFooterSection";
import PropTypes from "prop-types";

const StyledDrawer = styled(Stepper)((props) => ({
  "&.MuiStepper-root": {
    display: "flex",
    justifyContent: "space-between",
    gap: "16px !important",
    marginTop: "24px",
  },
  "& .MuiStep-root": {
    width: "100%",
    padding: "0px",
    marginBottom: "32px",
  },
  "& .MuiStepLabel-label": {
    fontSize: "16px",
    lineHeight: " 20px",
    color: "#C5C5C5 !important",
    fontFamily: "FordAntenna-Regular",
    borderBottom: "4px solid #E7E7E7",
    paddingBottom: "4px",

    "&.Mui-active": {
      width: "100%",
      color: "#2C3E50 !important",
      borderBottom: "4px solid #0B72D9",
    },
  },
  "& .MuiStepLabel-iconContainer": {
    display: "none",
  },

  "& .MuiStepConnector-root": {
    display: "none",
  },
}));

const MultistepForm = ({
  children,
  defaultValue,
  onSubmit,
  onCancel,
  hasHeader = true,
}) => {
  const [stepNumber, setStepNumber] = useState(0);
  const steps = React.Children.toArray(children);
  let initValue = JSON.parse(JSON.stringify(defaultValue));

  const [initialValues, setInitialValues] = useState(defaultValue);
  useEffect(() => {
    setInitialValues(initValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);
  const _ = require("lodash");
  const step = steps[stepNumber];
  const totalSteps = steps.length;

  const isLastStep = stepNumber === totalSteps - 1;

  const nextStep = (values) => {
    setInitialValues(values);
    setStepNumber(stepNumber + 1);
  };

  const previousStep = (values) => {
    setInitialValues(values);
    setStepNumber(stepNumber - 1);
  };

  const handleClick = (label, formik) => {
    if (label === "2.Contactgegevens" && !isLastStep) {
      formik.handleSubmit(() => {
        setInitialValues(formik.values);
        setStepNumber(1);
      });
    } else if (label === "1.Details") {
      setInitialValues(formik.values);
      setStepNumber(0);
    }
  };

  const handleSubmit = async (values, actions) => {
    if (step?.props.onSubmit) {
      await step?.props.onSubmit;
    }
    if (isLastStep) {
      return onSubmit(values, actions);
    } else {
      actions?.setTouched({});
      nextStep(values);
    }
  };

  return (
    <Box className={styles.MultistepFromWrapper} data-testid="MultistepForm">
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={_.get(step, "props.validationSchema")}
      >
        {(formik) => (
          <form
            onSubmit={formik.handleSubmit}
            className={styles.formContentWrapper}
          >
            {hasHeader ? (
              <StyledDrawer
                activeStep={stepNumber}
                className={styles.labelsDesign}
              >
                {steps.map((currentStep) => {
                  const label = currentStep.props.stepName;
                  return (
                    <Step key={label}>
                      <StepLabel onClick={() => handleClick(label, formik)}>
                        {i18next.t(label)}
                      </StepLabel>
                    </Step>
                  );
                })}
              </StyledDrawer>
            ) : (
              <Box className={styles.noHeaderSpace}></Box>
            )}

            {step}

            <FormFooterSection
              isLastStep={isLastStep}
              hasPrevious={stepNumber > 0}
              onBackClick={() => previousStep(formik.values)}
              onSubmit={() => handleSubmit()}
              onCancel={onCancel}
            />
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default MultistepForm;

export const FormStep = ({ stepName = "", children }) => children;

MultistepForm.propTypes = {
  children:PropTypes.any,
  defaultValue:PropTypes.any,
  onSubmit:PropTypes.any,
  onCancel:PropTypes.any,
  hasHeader:PropTypes.any
}